import { EmailLoginFormInputField, } from '..';
import { ActivateAccountFormInputField, ResetPasswordFormInputField, StartResetPasswordFormInputField, } from '../componentInterfaces';
import { BaseCompCtrl, } from './BaseCompCtrl';
/**
 * The types of input error that can happen to the input field
 */
export var EmailLoginFormErrorType;
(function (EmailLoginFormErrorType) {
    EmailLoginFormErrorType["EMPTY_EMAIL"] = "empty email";
    EmailLoginFormErrorType["INVALID_EMAIL"] = "invalid email";
    EmailLoginFormErrorType["EMPTY_PASSWORD"] = "empty password";
})(EmailLoginFormErrorType || (EmailLoginFormErrorType = {}));
/**
 * The types of input error that can happen to the input field
 */
export var StartResetPasswordFormErrorType;
(function (StartResetPasswordFormErrorType) {
    StartResetPasswordFormErrorType["EMPTY_EMAIL"] = "empty email";
    StartResetPasswordFormErrorType["INVALID_EMAIL"] = "invalid email";
})(StartResetPasswordFormErrorType || (StartResetPasswordFormErrorType = {}));
/**
 * The types of input error that can happen to the input field
 */
export var ResetPasswordFormErrorType;
(function (ResetPasswordFormErrorType) {
    ResetPasswordFormErrorType["EMPTY_PASSWORD"] = "empty new password";
    ResetPasswordFormErrorType["EMPTY_CONFIRM_PASSWORD"] = "empty confirm password";
    ResetPasswordFormErrorType["PASSWORDS_MISMATCH"] = "passwords mismatch";
})(ResetPasswordFormErrorType || (ResetPasswordFormErrorType = {}));
/**
 * The types of input error that can happen to the input field
 */
export var ActivateAccountFormErrorType;
(function (ActivateAccountFormErrorType) {
    ActivateAccountFormErrorType["EMPTY_NAME"] = "empty name";
    ActivateAccountFormErrorType["EMPTY_PASSWORD"] = "empty new password";
    ActivateAccountFormErrorType["EMPTY_CONFIRM_PASSWORD"] = "empty confirm password";
    ActivateAccountFormErrorType["PASSWORDS_MISMATCH"] = "passwords mismatch";
})(ActivateAccountFormErrorType || (ActivateAccountFormErrorType = {}));
/**
 * This is the BaseController for all logic related to Login. It is an ABSTRACT class because there is a few function that need to be implemented
 * by specific controller. This class does not know how to make API call so it can not implement those functions.
 */
export class BaseAuthCompCtrl extends BaseCompCtrl {
}
